import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchBox from "./SearchBox";

const navItems = [
  { label: "首页", to: "/", icon: "ri-home-5-line" },
  { label: "电影", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧", to: "/category/series", icon: "ri-tv-2-line" },
  { label: "关于", to: "/about", icon: "ri-information-line" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            日本在线观看
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBox />
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <div className="mb-3">
            <SearchBox />
          </div>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}